export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <path d="M20 54V26c0-8 5-13 12-13s12 5 12 13v28z" fill="none" stroke="#D62828" strokeWidth="3" />
    <path d="M38.5 30.5a7 7 0 1 0 0 8.5h-6" fill="none" stroke="#1C1917" strokeWidth="3" strokeLinecap="round" />
    <circle cx="32" cy="8" r="2.2" fill="#D62828" />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-2.5">
    <LogoMark />
    <span className="leading-none">
      <span className="font-display block text-2xl tracking-tight text-[#1C1917]">Guna</span>
      <span className="font-mono-g block text-[10px] uppercase tracking-[0.32em] text-[#D62828]">Stores · Off-licence</span>
    </span>
  </span>
);
